import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type IModalContentProps = HTMLAttributes<HTMLDivElement>;

export function ModalContent({
  children,
  className,
  ...rest
}: PropsWithChildren<IModalContentProps>) {
  return (
    <div
      className={twMerge(
        'flex flex-col relative overflow-x-hidden overflow-y-auto',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
